import { status } from './status';
import { update } from './update';

export const automation = {
  status,
  update,
};
